import Vue from 'vue'
import Vuex from 'vuex'
import tree from './modules/tree'
import common from './modules/common'
import menu from './modules/menu'
import operation from './modules/operation'
import router from './modules/router'
import user from './modules/user'
import company from './modules/company'
import cityProjectEnclosure from './modules/cityProjectEnclosure'
import notification from './modules/notification'
import projectSetting from './modules/projectSetting'
import setting from './modules/setting'
import confirmDialog from './modules/confirmDialog'
import cache from './modules/cache'

Vue.use(Vuex)
// 创建一个vuex实例
const store = new Vuex.Store({
  modules: {
    common,
    tree,
    menu,
    operation,
    router,
    user,
    company,
    cityProjectEnclosure,
    notification,
    projectSetting,
    setting,
    confirmDialog,
    cache
  }
  // // 定义存储的状态树
  // state: {},
  // // 派生计算
  // getters: {},
  // // 自定义事件触发存储
  // mutations: {},
  // // 可以包含任意异步操作
  // actions: {}
})
export default store



// WEBPACK FOOTER //
// ./src/vuex/index.js